/**
 * AiAgentSession — mirrors AgentSessionResponseDto from aumico-ms-ai-agents.
 *
 * Returned by GET /api/ai/sessions/:id
 */

import { AiAgentStatus } from './ai-agent-status.enum';

export interface AiAgentSession {
    sessionId: string;
    userId: string;
    organizationId: string;
    taskType: string;
    status: AiAgentStatus;
    input: Record<string, unknown> | null;
    output: Record<string, unknown> | null;
    trajectory: AiTrajectoryEntry[];
    chatHistory: AiChatMessage[];
    errorMessage: string | null;
    createdAt: string;
    updatedAt: string;
}

/** Returned by POST /api/ai/jobs */
export interface AiJobResponse {
    sessionId: string;
}

/** Returned by POST /api/ai/sessions/:id/chat */
export interface AiChatResponse {
    sessionId: string;
    /** Plain text fallback (used for chat history and as fallback for replyKey). */
    reply: string;
    /** i18n key for the reply — FE prefers this over `reply` when set. */
    replyKey?: string;
    /** Interpolation params for replyKey. */
    replyParams?: Record<string, unknown>;
    /** When the agent modifies its output (e.g. updated sections), the new output is returned here. */
    output?: Record<string, unknown> | null;
}

/** A single entry in the agent's execution trajectory */
export interface AiTrajectoryEntry {
    step: number;
    action: string;
    detail: Record<string, unknown>;
    timestamp: string;
}

/** A single chat message (user or agent) */
export interface AiChatMessage {
    role: 'user' | 'agent';
    /** Plain text fallback (LLM free text or English fallback for canned replies). */
    content: string;
    /** i18n key — rendered via i18next pipe when present (for canned agent replies). */
    contentKey?: string;
    /** Interpolation params for contentKey. */
    contentParams?: Record<string, unknown>;
    timestamp: string;
}
